import React from "react"
import config from "../../common/configuration"
import { useTranslation } from "react-i18next"

const Offsymbol = () => {
  const { t } = useTranslation()
    return (
      <div
        style={ config.form.switch.offsymbol}
      >
        {t("global:no")}
      </div>
    )
  }
  export default Offsymbol